export function buildAttachedSkillsBlock(
  skills: readonly { name: string }[]
): string {
  const names = skills.map((s) => `- ${s.name}`).join("\n");
  return `<attached-skills>\nThe user attached these skills — load each with the useSkill tool and follow its guidance:\n${names}\n</attached-skills>`;
}

export function prependAttachedSkills(
  text: string,
  skills: readonly { name: string }[]
): string {
  if (skills.length === 0) return text;
  const block = buildAttachedSkillsBlock(skills);
  return block + (text ? `\n\n${text}` : "");
}
